import CompraCreate from './CompraCreate'
export {CompraCreate}
export default CompraCreate
